module.exports = __webpack_public_path__ + "img/New PACI Flow - New-10.0ab9c9b7.png";